import React from 'react';
import classnames from 'classnames';

import "./manning-online-desktop.scss";
import { ManningOnlineStore } from '../../store/ManningOnlineStore';
import { ScrapbookIcon } from '../../../scrapbook/components/scrapbookIcon/ScrapbookIcon';
import { ManningOnlineDesk } from '../manningOnlineDesk/ManningOnlineDesk';

export interface IProps {
    store: ManningOnlineStore;
}
export interface IState {
}

export class ManningOnlineDesktop extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    private root: HTMLElement;
    
    constructor(props: IProps) {
        super(props);

        this.handleRootRef = this.handleRootRef.bind(this);
        this.handleStateChanged = this.handleStateChanged.bind(this);
        
        this.handleBorderPointerDown = this.handleBorderPointerDown.bind(this);
        this.finishBorderPointerInteraction = this.finishBorderPointerInteraction.bind(this);
        this.handlerBorderPointerMove = this.handlerBorderPointerMove.bind(this);

        this.state = {};
    }

    public componentDidMount(){
        this.hasBeenMounted = true;

        this.props.store.onDesktopChange(this.handleStateChanged);
        this.props.store.onReadingListChange(this.handleStateChanged);
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
        
        this.props.store.offDesktopChange(this.handleStateChanged);
        this.props.store.offReadingListChange(this.handleStateChanged);
        
        this.finishBorderPointerInteraction();
    }

    private handleStateChanged(){
        this.hasBeenMounted && this.forceUpdate();
    }

    public render(){
        return <div ref={this.handleRootRef} className={classnames("manning-online-desktop-root", {"_is-open": this.props.store.desktopState.isDesktopShown})}>
                    { this.renderContent()}
               </div>
    }

    private renderContent(){
        if(!this.props.store.desktopState.isDesktopShown) { return null; }
        
        return <>
                    <div className={classnames("_main", { "is-maximized": this.props.store.desktopState.isMaximized})}>
                        <div className="_left-column">
                            <ScrapbookIcon onClick={this.props.store.toggleScrapbook}/>
                        </div>
                        <div className="_right-column">
                            <ManningOnlineDesk store={this.props.store}/>
                        </div>
                    </div>
                    <div className="_border" onDoubleClick={this.props.store.toggleMaximizeDesktop}
                                             onMouseDown={this.handleBorderPointerDown}
                                             onTouchStart={this.handleBorderPointerDown}></div>
                </>
    }

    public componentDidUpdate(){
        if(this.root != null){
            setTimeout(() => {
                if(!this.root || !this.hasBeenMounted) { return; }
                
                const mainContainer: HTMLElement = this.root != null ? this.root.querySelector("._main") : null;
                if(mainContainer == null) { return; }

                if(this.props.store.desktopState.isDesktopShown){
                    mainContainer.classList.add("is-open");
                }
                else {
                    mainContainer.classList.remove("is-open");
                }
            }, 16);
        }
    }

    private handleRootRef(root: HTMLElement){
        this.root = root;

        if(this.root != null){
            this.root.style.setProperty("--height", this.props.store.desktopState.defaultHeight);
        }
    }

    private borderDragInfo: {
        startingPoint: {
            y: number
        },
        initialHeight: number,
        referentContainer: HTMLElement
    } = null
    
    private handleBorderPointerDown(e){
        const referentContainer: HTMLElement = this.root != null ? this.root.querySelector("._main") : null;

        this.borderDragInfo = {
            startingPoint: { y: e.pageY },
            referentContainer: referentContainer,
            initialHeight: referentContainer != null ? referentContainer.getBoundingClientRect().height : 0
        };

        if(this.root != null){
            this.root.classList.add("_is-being-resized");
        }
        
        document.addEventListener("mousemove", this.handlerBorderPointerMove);
        document.addEventListener("touchmove", this.handlerBorderPointerMove);
        
        document.addEventListener("mouseup", this.finishBorderPointerInteraction);
        document.addEventListener("mouseleave", this.finishBorderPointerInteraction);
        document.addEventListener("touchend", this.finishBorderPointerInteraction);
    }

    private handlerBorderPointerMove(e) {
        const difference = this.borderDragInfo.startingPoint.y - e.pageY;

        let height = this.borderDragInfo.initialHeight - difference;
        if(height < 340) { height = 340; }
        if(height > (window.innerHeight - 170)){ height = window.innerHeight - 170; }

        if(this.root != null){
            this.root.style.setProperty('--height', `${height}px`);
        }
    }

    private finishBorderPointerInteraction(e?){
        if(this.root != null){
            this.root.classList.remove("_is-being-resized");

            if(e != null){
                const style = window.getComputedStyle(this.root);
                this.props.store.updateDesktopDefaultHeight(parseInt(style.getPropertyValue("--height")));
            }
        }
        
        this.borderDragInfo = null;
        this.unsubscribeFromPointerEvents();
    }

    private unsubscribeFromPointerEvents(){
        document.removeEventListener("mousemove", this.handlerBorderPointerMove);
        document.removeEventListener("touchmove", this.handlerBorderPointerMove);
        
        document.removeEventListener("mouseup", this.finishBorderPointerInteraction);
        document.removeEventListener("mouseleave", this.finishBorderPointerInteraction);
        document.removeEventListener("touchend", this.finishBorderPointerInteraction);
    }
}